import {gql} from 'apollo-boost';

export const removeOrganisationMutation = gql`
    mutation removeOrganisation($id: Int!) {
        removeOrganisation(id: $id)
    }
`;
